// extracted by mini-css-extract-plugin
module.exports = {"content":"_2IWiMjLcIgRFgc3c1au9H9","btn":"_3jJgWofZKtNNJB7klrOn6O"};